module.exports = __webpack_public_path__ + "static/media/computerLandingBriiing.215b20bd.webp";